import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { Task } from '../../../../shared/entities/task/task';
import { ControlTemplate } from '../../../form/entities/controlTemplate';
import { EditDialogService } from '../../../../../core/components/editDialog/editDialogService';
import { ViewDialogService } from '../../../../../core/components/viewDialog/viewDialogService';
import { CommandTemplate } from '../../../../../core/entities/commandTemplate/commandTemplate';
import { TaskFormHandler } from '../task-form-handler.interface';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { RefuelFormDialogComponent } from './refuel-form-dialog.component';
import { FormViewDialogComponent } from './form-view-dialog.component';

/**
 * Refuel form view component for resource refueling tasks
 */
@Component({
  selector: 'app-refuel-form-view',
  template: `
    <div>
      @if(template()?.body; as body) {
        @for (bodyItem of body; track bodyItem.key) {
        <div class="top flex flex-col px-5 py-[0.313rem] bg-white min-w-[485px] block border-b border-gray first:border-t ng-star-inserted">
          <div class="flex flex-row">
            <div class="grow">
              <div class="flex flex-row">
                <div class="text-base font-medium leading-3r cursor-pointer">
                  {{bodyItem?.settings?.listViewLabel}}
                </div>
              </div>
              <div class="text-base text-[#848488] leading-3 ng-star-inserted">
                {{bodyItem?.settings?.listViewSubLabel}}
              </div>
            </div>
            @if (!isNotCompleted()) {
            <div class="self-center">
              <nx-default-button
                [style]="'dark'"
                (click)="view()"
                [disabled]="false"
                [icon]="'icon-search'">
              </nx-default-button>
            </div>
            }
          </div>
        </div>
        }
      }
    </div>
    <div class="flex justify-end mt-2">
      @if(isNotCompleted()) {
      <nx-default-button
        [style]="'accent'"
        [disabled]="disabled()"
        [pTooltip]="disabled() ? 'Im Web nicht verfügbar.' : undefined"
        [label]="'Start'"
        (click)="start()">
      </nx-default-button>
      } @else {
      <nx-default-button
        [style]="'accent'"
        [disabled]="true"
        [label]="'Erledigt'">
      </nx-default-button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RefuelFormViewComponent {
  readonly task = input.required<Task>();
  readonly template = input<ControlTemplate | null>(null);
  readonly commandTemplate = input<CommandTemplate | null>(null);
  readonly disabled = input(true);
  readonly handler = input.required<TaskFormHandler>();
  
  readonly isNotCompleted = computed(() => this.task()?.state !== 'COMPLETED');
  
  readonly complete = output<any>();

  // Injected services
  private readonly editDialogService = inject(EditDialogService);
  private readonly viewDialogService = inject(ViewDialogService);
  
  dialogRef: DynamicDialogRef | undefined;

  start() {
    this.dialogRef = this.editDialogService.open(RefuelFormDialogComponent, {
      header: 'Nachtanken',
      confirmLabel: 'Als erledigt markieren',
      width: '400px',
      data: {
        task: this.task(),
        template: this.template()
      }
    });
    
    this.dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.complete.emit(result);
      }
    });
  }

  view() {
    this.dialogRef = this.viewDialogService.open(FormViewDialogComponent, {
      header: this.template()?.settings?.label,
      closeLabel: 'Schließen',
      width: '500px',
      data: {
        template: this.template()
      }
    });
    
    this.dialogRef.onClose.subscribe((result) => {
      if (result) {
        this.complete.emit(result);
      }
    });
  }
}
